import { render } from "./landing-tabs.vue?vue&type=template&id=73d66e43&scoped=true"
import script from "./landing-tabs.vue?vue&type=script&lang=js"
export * from "./landing-tabs.vue?vue&type=script&lang=js"

import "./landing-tabs.vue?vue&type=style&index=0&id=73d66e43&scoped=true&lang=scss"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d66e43"]])

export default __exports__